/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { getStyleOverrides } from '@/utils/getStyleOverrides';
import { ThemeOptions } from '@mui/material/styles';

export const Checkbox: ThemeOptions = {
	components: {
		MuiCheckbox: {
			styleOverrides: {
				root: getStyleOverrides({
					styles: {
						stroke: 'white',
						 "& input:focus-visible + svg": {
							outline: `2px solid #000`,
							outlineOffset: 1,
							borderRadius: 0.1,
						}
					},
				}),
			},
		},
	},
};
